import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import {
    apiListRoles,
    apiListUsers,
    apiListCustomers,
    apiListInspectors,
    apiListProjects,
    apiListTransformers,
    apiListTestTypes,
    apiListGlobals,
    apiListCoolingTypes,
    apiListReferenceStandards,
    apiListWindingMaterials,
    apiListEquipments,
    apiListDiagrams,
    apiListTransformerTests,
    apiListFeedbacks,
    apiListLabSurfaceAreas,
} from 'Services/AdminService'

export const getRoles = createAsyncThunk('admin/list/getRoles', async () => {
    const { data } = await apiListRoles()
    return data
})

export const getUsers = createAsyncThunk('admin/list/getUsers', async () => {
    const { data } = await apiListUsers()
    return data
})

export const getCustomers = createAsyncThunk('admin/list/getCustomers', async () => {
    const { data } = await apiListCustomers()
    return data
})

export const getInspectors = createAsyncThunk('admin/list/getInspectors', async () => {
    const { data } = await apiListInspectors()
    return data
})

export const getProjects = createAsyncThunk('admin/list/getProjects', async () => {
    const { data } = await apiListProjects()
    return data
})

export const getTransformers = createAsyncThunk('admin/list/getTransformers', async id => {
    const { data } = await apiListTransformers(id)
    return data
})

export const getTestTypes = createAsyncThunk('admin/list/getTestTypes', async id => {
    const { data } = await apiListTestTypes(id)
    return data
})

export const getGlobals = createAsyncThunk('admin/list/getGlobals', async () => {
    const { data } = await apiListGlobals()
    return data
})

export const getCoolingTypes = createAsyncThunk('admin/list/getCoolingTypes', async () => {
    const { data } = await apiListCoolingTypes()
    return data
})

export const getReferenceStandards = createAsyncThunk('admin/list/getReferenceStandards', async () => {
    const { data } = await apiListReferenceStandards()
    return data
})

export const getWindingMaterials = createAsyncThunk('admin/list/getWindingMaterials', async () => {
    const { data } = await apiListWindingMaterials()
    return data
})

export const getEquipments = createAsyncThunk('admin/list/getEquipments', async () => {
    const { data } = await apiListEquipments()
    return data
})

export const getDiagrams = createAsyncThunk('admin/list/getDiagrams', async () => {
    const { data } = await apiListDiagrams()
    return data
})

export const getLabSurfaceAreas = createAsyncThunk('admin/list/getLabSurfaceAreas', async () => {
    const { data } = await apiListLabSurfaceAreas()
    return data
})

export const getTransformerTests = createAsyncThunk('admin/list/getTransformerTests', async id => {
    const { data } = await apiListTransformerTests(id)
    return data
})

export const getFeedbacks = createAsyncThunk('admin/list/getFeedbacks', async () => {
    const { data } = await apiListFeedbacks()
    return data
})

export const listSlice = createSlice({
    name: 'admin/list',
    initialState: {
        loading: true,
        roles: [],
        users: [],
        customers: [],
        inspectors: [],
        projects: [],
        transformers: [],
        testTypes: [],
        globals: [],
        coolingTypes: [],
        referenceStandards: [],
        windingMaterials: [],
        equipments: [],
        diagrams: [],
        labSurfaceAreas: [],
        tests: [],
        feedbacks: [],
    },
    extraReducers: builder => {
        builder
            .addCase(getRoles.fulfilled, (state, { payload }) => {
                state.roles = payload
            })
            .addCase(getRoles.rejected, state => {
                state.roles = []
            })

            .addCase(getUsers.fulfilled, (state, { payload }) => {
                state.users = payload
            })
            .addCase(getUsers.rejected, state => {
                state.users = []
            })

            .addCase(getCustomers.fulfilled, (state, { payload }) => {
                state.customers = payload
            })
            .addCase(getCustomers.rejected, state => {
                state.customers = []
            })

            .addCase(getInspectors.fulfilled, (state, { payload }) => {
                state.inspectors = payload
            })
            .addCase(getInspectors.rejected, state => {
                state.inspectors = []
            })

            .addCase(getProjects.fulfilled, (state, { payload }) => {
                state.projects = payload
            })
            .addCase(getProjects.rejected, state => {
                state.projects = []
            })

            .addCase(getTransformers.fulfilled, (state, { payload }) => {
                state.transformers = payload
            })
            .addCase(getTransformers.rejected, state => {
                state.transformers = []
            })

            .addCase(getTestTypes.fulfilled, (state, { payload }) => {
                state.testTypes = payload
            })
            .addCase(getTestTypes.rejected, state => {
                state.testTypes = []
            })

            .addCase(getGlobals.pending, state => {
                state.loading = true
            })
            .addCase(getGlobals.fulfilled, (state, { payload }) => {
                state.loading = false
                state.globals = payload
            })
            .addCase(getGlobals.rejected, state => {
                state.loading = false
                state.globals = []
            })

            .addCase(getCoolingTypes.fulfilled, (state, { payload }) => {
                state.coolingTypes = payload
            })
            .addCase(getCoolingTypes.rejected, state => {
                state.coolingTypes = []
            })

            .addCase(getReferenceStandards.pending, state => {
                state.loading = true
            })
            .addCase(getReferenceStandards.fulfilled, (state, { payload }) => {
                state.loading = false
                state.referenceStandards = payload
            })
            .addCase(getReferenceStandards.rejected, state => {
                state.loading = false
                state.referenceStandards = []
            })

            .addCase(getWindingMaterials.fulfilled, (state, { payload }) => {
                state.windingMaterials = payload
            })
            .addCase(getWindingMaterials.rejected, state => {
                state.windingMaterials = []
            })

            .addCase(getEquipments.fulfilled, (state, { payload }) => {
                state.equipments = payload
            })
            .addCase(getEquipments.rejected, state => {
                state.equipments = []
            })

            .addCase(getDiagrams.fulfilled, (state, { payload }) => {
                state.diagrams = payload
            })
            .addCase(getDiagrams.rejected, state => {
                state.diagrams = []
            })

            .addCase(getLabSurfaceAreas.fulfilled, (state, { payload }) => {
                state.labSurfaceAreas = payload
            })
            .addCase(getLabSurfaceAreas.rejected, state => {
                state.labSurfaceAreas = []
            })

            .addCase(getTransformerTests.fulfilled, (state, { payload }) => {
                state.tests = payload
            })
            .addCase(getTransformerTests.rejected, state => {
                state.tests = []
            })

            .addCase(getFeedbacks.fulfilled, (state, { payload }) => {
                state.feedbacks = payload
            })
            .addCase(getFeedbacks.rejected, state => {
                state.feedbacks = []
            })
    },
})

export default listSlice.reducer
